{
  "actions": {
    "back": "Back",
    "close": "Close",
    "minimize": "Minimize",
    "maximize": "Maximize",
    "restore": "Restore",
    "open": "Open",
    "save": "Save",
    "cancel": "Cancel"
  },
  "ui": {
    "loading": "Loading...",
    "ready": "Ready",
    "error": "Something went wrong",
    "success": "Success!",
    "clickForDetails": "Click for details"
  },
  "status": {
    "online": "Online",
    "offline": "Offline",
    "busy": "Busy",
    "available": "Available"
  },
  "navigation": {
    "home": "Home",
    "back": "Back",
    "next": "Next",
    "previous": "Previous"
  }
}